"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Returns true if the value is NOT null or undefined.
 *
 * @category Lang
 * @param {*} value - The value to check
 * @returns {boolean}
 * @example
 * isNotNull(null)      // returns false
 * isNotNull(undefined) // returns false
 * isNotNull('')        // returns true
 * isNotNull({})        // returns true
 * isNotNull([])        // returns true
 */
var _default = function _default(value) {
  return value !== null && value !== undefined;
};

exports.default = _default;